import React, { PureComponent } from 'react';

import Avatar from './avatar';

export default class UserAvatar extends PureComponent {
    render() {
        const props = this.props;
        return (
            <Avatar
                image={props.avatar}
                timezone={props.tz}
                email={props.email}
                text={props.initials}
                secondaryColor={props.secondary_color}
                {...props}
            />
        )
    }
}
